// Module
var code = "<div class=\"close\" ng-click=\"vm.cancel()\"><div class=\"fa fa-times\"></div></div><h3>Thanks for Requesting to Join</h3><p>An admin will review your request soon.</p><div class=\"row\"><div class=\"col-sm-12\"> <a ng-click=\"vm.cancel()\" class=\"btn-c2a fill style-plain\">Close</a></div></div>";
// Exports
module.exports = code;